<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/82HS2g/tc-custom/9780316223966.jpg?1731883592307" alt="This image is the cover for the book Take Back the Sky, War Dogs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Take Back the Sky, War Dogs
      </h1>
      <p class="bookDescription body article font2">
        <b>The conclusion to an epic interstellar trilogy of war from master of science fiction, Greg Bear.</b><b><br/></b><br/>Marooned beneath the icy, waxy crust of Saturn's moon, Titan, Skyrine Michael Venn and his comrades face double danger from Earth and from the Antagonists, both intent on wiping out their growing awareness of what the helpful alien Gurus are really doing in our solar system.<br/><br/>Haunted by their dead and by the ancient archives of our Bug ancestors, the former combatants must now team up with their enemies, forget their indoctrination and their training, and journey far beyond Pluto to the fabled Planet X, the Antagonists' home world, a Sun-Planet in the comet-generating Kuiper belt. It's here that Master Sergeant Venn will finally understand his destiny and the destiny of every intelligent being in the solar system-including the enigmatic Gurus.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Greg Bear
      </h2>
      
      <p class="authorDescription body article">&amp;lt;B&amp;gt;Greg Bear&amp;lt;/B&amp;gt; is the author of more than thirty books of science fiction and fantasy, including &amp;lt;I&amp;gt;Forerunner: Cryptum, Mariposa, Darwin's Radio, Eon&amp;lt;/I&amp;gt;, and &amp;lt;I&amp;gt;Quantico&amp;lt;/I&amp;gt;. He is married to Astrid Anderson Bear and is the father of Erik and Alexandra. His works have been published internationally in over twenty languages. Bear has been called the "Best working writer of hard science fiction" by the &amp;lt;I&amp;gt;Ultimate Encyclopedia of Science Fiction&amp;lt;/I&amp;gt;.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Orbit
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1a72d15b